import { render, staticRenderFns } from "./ImportFilePopup.vue?vue&type=template&id=65ff63af&scoped=true&"
import script from "./ImportFilePopup.vue?vue&type=script&lang=js&"
export * from "./ImportFilePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImportFilePopup.vue?vue&type=style&index=0&id=65ff63af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff63af",
  null
  
)

export default component.exports